<!-- Start Inner Banner -->
<div class="inner-banner inner-bg7">
    <div class="container">
        <div class="inner-title text-center">
            <h3>Services</h3>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li><i class='bx bxs-chevron-right'></i></li>
                <li>Services</li>
            </ul>
        </div>
    </div>
</div>
<!-- Inner Banner End -->

<!-- Start Services Area -->
<div class="service-area pt-100 pb-70">
    <div class="container">
        <div class="section-title text-center">
            <span class="span-bg">Services</span>
            <h2>We Always Ready to Serve You the Best Service</h2>
            <p>We have a good expert in the global market and this will help us to make a good image on our service market and globally.</p>
        </div>

        <div class="row pt-45">
            <div class="col-lg-4 col-md-6">
                <div class="service-card">
                    <a routerLink="/service-details">
                        <img src="assets/img/services/services-img1.jpg" alt="Images">
                    </a>
                    <div class="content">
                        <i class="flaticon-wheel"></i>
                        <i class="flaticon-wheel service-icon-bg"></i>
                        <h3><a routerLink="/service-details">Wheel Adjustment</a></h3>
                        <p>We are always help to make one of the best adjustment service.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="service-card">
                    <a routerLink="/service-details">
                        <img src="assets/img/services/services-img2.jpg" alt="Images">
                    </a>
                    <div class="content">
                        <i class='flaticon-settings'></i>
                        <i class="flaticon-settings service-icon-bg"></i>
                        <h3><a routerLink="/service-details">Engine Servicing</a></h3>
                        <p>We are always help to make one of the best adjustment service.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="service-card">
                    <a routerLink="/service-details">
                        <img src="assets/img/services/services-img3.jpg" alt="Images">
                    </a>
                    <div class="content">
                        <i class='flaticon-racing'></i>
                        <i class="flaticon-racing service-icon-bg"></i>
                        <h3><a routerLink="/service-details">Tyre Service</a></h3>
                        <p>We are always help to make one of the best adjustment service.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="service-card">
                    <a routerLink="/service-details">
                        <img src="assets/img/services/services-img4.jpg" alt="Images">
                    </a>
                    <div class="content">
                        <i class='flaticon-disc-brake'></i>
                        <i class="flaticon-disc-brake service-icon-bg"></i>
                        <h3><a routerLink="/service-details">Brake Service</a></h3>
                        <p>We are always help to make one of the best adjustment service.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="service-card">
                    <a routerLink="/service-details">
                        <img src="assets/img/services/services-img5.jpg" alt="Images">
                    </a>
                    <div class="content">
                        <i class='flaticon-car-service-1'></i>
                        <i class="flaticon-car-service-1 service-icon-bg"></i>
                        <h3><a routerLink="/service-details">Washing Service</a></h3>
                        <p>We are always help to make one of the best adjustment service.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="service-card">
                    <a routerLink="/service-details">
                        <img src="assets/img/services/services-img6.jpg" alt="Images">
                    </a>
                    <div class="content">
                        <i class='flaticon-car-service'></i>
                        <i class="flaticon-car-service service-icon-bg"></i>
                        <h3><a routerLink="/service-details">Polishing Service</a></h3>
                        <p>We are always help to make one of the best adjustment service.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-12 col-md-12">
                <div class="pagination-area">
                    <a routerLink="/services-2" class="prev page-numbers"><i class="bx bx-chevron-left"></i></a>
                    <span class="page-numbers current" aria-current="page">1</span>
                    <a routerLink="/services-2" class="page-numbers">2</a>
                    <a routerLink="/services-2" class="page-numbers">3</a>
                    <a routerLink="/services-2" class="next page-numbers"><i class="bx bx-chevron-right"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Services Area End -->